/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	CompanyDocumentDTO,
	CompanyDocumentDTOFromJSON,
	CompanyDocumentDTOFromJSONTyped,
	CompanyDocumentDTOToJSON,
} from "./CompanyDocumentDTO";

/**
 *
 * @export
 * @interface CompanyDocumentDTOPagedResponse
 */
export interface CompanyDocumentDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof CompanyDocumentDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyDocumentDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyDocumentDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<CompanyDocumentDTO>}
	 * @memberof CompanyDocumentDTOPagedResponse
	 */
	data?: Array<CompanyDocumentDTO> | null;
}

export function CompanyDocumentDTOPagedResponseFromJSON(
	json: any
): CompanyDocumentDTOPagedResponse {
	return CompanyDocumentDTOPagedResponseFromJSONTyped(json, false);
}

export function CompanyDocumentDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyDocumentDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(CompanyDocumentDTOFromJSON),
	};
}

export function CompanyDocumentDTOPagedResponseToJSON(
	value?: CompanyDocumentDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(CompanyDocumentDTOToJSON),
	};
}
